var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h3', {
    staticClass: "my-15"
  }, [_vm._v("Titre et accroche")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-5"
  }, [_c('p', {
    staticClass: "uppercase text-indigo-600 text-base font-normal"
  }, [_vm._v("Titre de mon CV")]), _vm._v(" "), _c('p', {
    staticClass: "text-base font-light"
  }, [_vm._v("Le titre, reflète votre objectif professionnel ou poste visé (maximum 50 caractères).")]), _vm._v(" "), _c('input-text', {
    attrs: {
      "name": "title",
      "value": (_vm.form || {}).name || '',
      "placeholder": "Titre de mon CV",
      "error": true,
      "maxlength": 50,
      "msg-error": ((_vm.errors || []).name || [])[0]
    },
    on: {
      "input": function (newValue) {
        (_vm.form || {}).name = newValue;
        (_vm.errors || []).name = [];
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-10 flex flex-col space-y-5"
  }, [_c('p', {
    staticClass: "uppercase text-indigo-600 text-base font-normal"
  }, [_vm._v("Accroche")]), _vm._v(" "), _c('p', {
    staticClass: "text-base font-light"
  }, [_vm._v("\n            L’accroche a pour but d’attirer l’attention du recruteur et de vous démarquer des  autres candidats. Enquelques mots, elle doit faire comprendre au recruteur le métier recherché et lui donner envie de vous renvontrer.\n        ")]), _vm._v(" "), _c('input-text-area', {
    attrs: {
      "name": "accroche",
      "value": (_vm.form || {}).description || '',
      "placeholder": "Accroche",
      "error": true,
      "maxlength": _vm.form.type === _vm.constants.CV_TYPES.DASHBOARD ? 250 : 400,
      "size": 5,
      "msg-error": ((_vm.errors || []).description || [])[0]
    },
    on: {
      "input": function (newValue) {
        (_vm.form || {}).description = newValue;
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }